<template>
  <div></div>
</template>

<script>
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  setup() {
    const router = useRouter();
    const store = useStore();
    store.commit("setCurrentRoute", "Zones");
    router.replace({ name: "Zones" });
    return {};
  },
};
</script>
